import { actionEmitter, EmitEvent } from "../config/ActionEmitter";
import { IApiResponse, ILanguage } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class LanguageService extends BaseService {

  public getSiteLanguages = async() : Promise<ILanguage[]> => {
    if (this.siteKey) {
        const url = `/SiteAdmin/GetLanguages/${this.siteKey}`;
        const res = await this._ajaxService.Get<IApiResponse>(url, true);
        if (res?.Success && res?.ReturnData) {
          return res.ReturnData;
        }
    }
    return [];
  }

  public saveLanguage = async (lang: ILanguage) : Promise<ILanguage | null> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/AddUpdateLanguage`;
      const res = await this._ajaxService.Post<IApiResponse>(url, { ...lang, SiteId: this.siteKey }, true);

      if (res?.Success && res.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save language");
      }
    }
    return null;
  }

  public deleteLanguage = async (id: number) : Promise<boolean> => {
    if (this.siteKey && id > 0) {
      const url: string = `/SiteAdmin/DeleteLanguage/${this.siteKey}/${id}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.Success && res.StatusCode === 200) {
        return true;
      } else {
        this.EmitDataError(res, "Failed to remove site language");
      }
    }
    return false;
  }

  public newLanguage = () : ILanguage | null => {
    if (this.siteKey) {
      return {
        Id: 0,
        Enabled: true,
        Language: "",
        ShortCode: "",
        SiteId: this.siteKey
      };
    }
    return null;
  }
}